
window.fwSettings={
  'widget_id':77000001923
  };
  !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}() 
  FreshworksWidget('hideChoices', 'ticketForm', {
    'custom_fields': {
      'cf_solution_type_bharath': ['Ad testing and development', 'Brand insights', 'Innovation and product development', 'Consumer and retail trends', 'Media planning and effectiveness', 'Quick turn custom surveys']
    }
  });

 //Auto fill for help widget
 
  let data = JSON.parse(sessionStorage.getItem("userInfo"));
  let name = data.fullName;
  let email = data.emailId;

  FreshworksWidget('identify', 'ticketForm', {
    name: name,
    email: email,
  });
  